import { useTranslation } from "react-i18next";
import { useRemoteMutation } from "../../useRemote/useRemoteMutation";
import { RemoteApiError } from "../../useRemote/types";
import { CateringMenuAssignmentDto } from "../../../../components/FacilityManager/Domain/Types/FloorPlan/CateringMenuAssignment.type";

export function useRemoteAssignCateringServices() {
  const { t } = useTranslation();
  return useRemoteMutation<void, RemoteApiError, CateringMenuAssignmentDto>({
    key: ["assign-catering-services"],
    url: "/booking-services/assigned-services",
    method: "put",
    snackbarTextOnFail: t("There was a server error")
  });
}
